import React from "react";
import AppLayout from "./AppLayout";

/**
 * DashboardLayout
 * ----------------------------------------------------------------------------
 * Every inner page (vendors, invoices, reports, update-data, role-assign, …)
 * wraps its content in <DashboardLayout>. It now renders the SAME polished
 * shell used by the Home and Master/Dashboard pages — the charcoal sidebar
 * with real per-item icons, active/hover states, the header controls and the
 * light/dark theme toggle — so the whole app shares one consistent chrome.
 *
 * It still accepts `children` like before; the optional eyebrow/title/accent
 * props let a page show a header heading if it wants one (most pages render
 * their own in-content heading, so these stay optional).
 */
const DashboardLayout = ({ children, eyebrow, title, titleAccent }) => (
    <AppLayout eyebrow={eyebrow} title={title} titleAccent={titleAccent}>
        {children}
    </AppLayout>
);

export default DashboardLayout;
